import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ENROLLMENT_TYPES = [
  {
    label: <FormattedMessage id="mdm.policy.display.filter.fm" />,
    value: 'FULLY_MANAGED'
  }
  // {
  //   label: 'KIOSK',
  //   value: 'KIOSK'
  // }
] as const;

export const DEVICE_CATEGORIES = [
  {
    label: 'Mobile Phones',
    value: 'mobile-phones'
  },
  {
    label: 'Tablets',
    value: 'tablets'
  },
  {
    label: 'Laptops',
    value: 'laptops'
  },
  {
    label: 'Desktops',
    value: 'desktops'
  }
] as const;

export const TABS_CONFIG = [
  {
    content: <FormattedMessage id="mdm.settings.Android" />,
    disabled: false,
    id: 'android',
    panelID: 'android-panel',
    iconName: 'Android'
  },
  {
    content: <FormattedMessage id="mdm.settings.Apple" />,
    id: 'ios',
    panelID: 'ios-panel',
    iconName: 'Apple'
  }
] as const;

export const DEFAULT_ENROLLMENT_TYPE = ['FULLY_MANAGED'];
